var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_1737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4163 5.87551L16.1238 4.58301L10.9997 9.70717L5.87551 4.58301L4.58301 5.87551L9.70717 10.9997L4.58301 16.1238L5.87551 17.4163L10.9997 12.2922L16.1238 17.4163L17.4163 16.1238L12.2922 10.9997L17.4163 5.87551Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_1737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossModal);
export default __webpack_public_path__ + "static/media/crossModal.07dc6c77bea490dad6de941bf659d93d.svg";
export { ForwardRef as ReactComponent };